export function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export function getDomainFromUrl(url) {
    const urlObj = new URL(url)
    return urlObj.hostname
}
